import { fCurrency, getIncomeEntry } from '../../utils'
import { useEffect, useState } from 'react'
import { Spinner } from 'components'

const IncomeEntryCell = ({ id, month, incomeType, trackerEntries }) => {
  const [entry, setEntry] = useState(null)

  useEffect(() => {
    getIncomeEntry(id, month, incomeType, trackerEntries).then((item) => {
      setEntry(item)
    })
  }, [trackerEntries])

  return entry == null ? (
    <td>
      <Spinner />
    </td>
  ) : entry.data == null ? (
    <td> - </td>
  ) : (
    <td>{fCurrency(entry.data.amount)}</td>
  )
}

export default IncomeEntryCell
